// @ts-check
export class FetchUtils{
/**
 * 
 * @param {any} main 
 */
constructor(main){
    this.main = main;
    this.errorMessage = 'An unexpected error occurred';
}

/**
 * 
 * @param {any} state 
 * @returns 
 */
async fetch(state){
this.main.log(state,0,'FetchUtils.fetch(): state');
this.main.spin();
state = this.main.utils.clone(state);
if(!state.method){
state.method = (state.body)?'POST' :'GET';
}
let headers = new Headers();
headers.append("sp","sp");
headers.append("Content-Type", "application/json");
let option = {headers:headers,method:state.method};
//let option = {headers:headers,method:state.method,credentials: 'include'};
if((!this.main.isView) || (state.component=='login') || (state.component=='register')){
option.credentials = 'include';
}
if(state.body){
    option.body = state.body;
}
//const controller = new AbortController();
option.signal = AbortSignal.timeout(60000);//60 seconds
//const timeoutId = setTimeout(() => controller.abort(), 500000000000); // 50 second timeout
//now
let request = new Request(state.link,option);
let response;
let responseJson;
let attempt = 1;

while(attempt<4){
try{
response = await window.fetch(request);
if(!response.ok){
    throw new Error();
}
}catch(error){
response = null;
this.main.log(error,'FetchUtils.fetch(): fetch error');
if(error.name=='AbortError' || attempt==3){
    this.processError(error,state);
}
attempt++;
let delay = this.getLinearDelay(attempt);
await new Promise(resolve => setTimeout(resolve, delay));
continue;
}// end fetch
//here, fetch has succeded, so end loop
attempt = 4;
this.main.spin(false);
let notifications = document.querySelectorAll('.notification') || [];
for(let n of notifications){
    n.innerHTML = '';
}
responseJson = await response.json();
//NOW PROCESS RESULT
this.main.log(responseJson,'FetchUtils.fetch(): responseJson');
if(typeof responseJson=='object' && ('errorMessage' in responseJson && !this.main.utils.isNull(responseJson.errorMessage))){
   this.main.handleError(responseJson,state);
}//
else{
   //no error here, process response normally
        return responseJson.result;
}
}//end while
}//func

/**
 * 
 * @param {Error} error 
 * @param {any} state 
 */
processError(error,state){
this.main.log(error,'FetchUtils.processError(): fetch error');
if(this.isNetworkError(error)){
    if(this.main.isView){
        this.main.navigate({component:'post',url:'page/connection-error',isView:true,hasError:true,message:"",errorType:"internet"});
    }else{
        this.main.utils.notify('Please check your internet connection.',{level:2});
    }
}else if(error.name=='TimeoutError' /**'AbortError'*/){
        if(this.main.isView){
        this.main.navigate({component:'post',url:'page/timedout',isView:true,hasError:true,message:"",errorType:"timedout"});
    }else{
        this.main.utils.notify('Request timeout. Please check your internet connection and try again.',{level:2});
    }
}else{
    //this is a backend error
    if(this.main.isView){
        this.main.navigate({component:'post',url:'page/404',isView:true,hasError:true,message:"",errorType:"generic"});
    }else{
        this.main.utils.notify(this.main.config.ERROR_MESSAGE,{level:1});
    }
}
this.main.die();
}//func

/**
 * 
 * @param {Error} error 
 */
isNetworkError(error){
return (
    error.name === 'TypeError' &&

    (error.message === 'Failed to fetch' ||
     error.message.includes('NetworkError') ||
     error.message.includes('network'))
    ) 
    
    ||
  error.message === 'Network request failed' ||
  //error.code === 'ECONNABORTED' ||
  error.message.includes('net::ERR_INTERNET_DISCONNECTED') ||
  error.message.includes('net::ERR_NETWORK_CHANGED');
}//func

/**
 * 
 * @param {number} attempt 
 * @returns 
 */
getLinearDelay(attempt=1) {
  const baseDelay = 2000;
  return baseDelay * attempt; // 1s, 2s, 3s, 4s...
  //4+6+8
}//func

/**
 * 
 * @param {any} data 
 * @returns 
 */
async fetchExt(data){
let headers = new Headers();
if(data.authToken){
headers.append("Authorization", `Bearer ${data.authToken}`);
}
if(data.contentType){
headers.append("content-Type", data.contentType);   
}
//note: method is set explicitely
let option = {headers:headers,method:data.method};
if(data.body){
    option.body = data.body;
}
//now
let request = new Request(data.link,option);
try{
let response = await window.fetch(request);
this.main.log(response,'FetchUtils.fetchExt(): response');
if(response.ok){
if(data.noResponse){
return true;
}else{
let responseJson = await response.json();
this.main.log(responseJson,'FetchUtils.fetchExt(): responseJson');
return responseJson;
}
}
}catch(error){
this.main.log(error,'FetchUtils.fetchExt(): fetch error');
this.main.utils.notify(this.errorMessage,{level:2});
throw new Error();
}// end fetch
}//func

//########## GENERAL ##########
/**
 * 
 * @param {string|null} path; 
 * @param {string[]|null} searchParams; 
 * @returns 
 */
getApi(path,searchParams=null){
let apiBase;
if(this.main.isDev() || this.main.isStage){
apiBase = 'http://localhost:8081/api';
}else{
apiBase = 'https://senplat.com/api';
}
//apiBase = 'http://localhost:8081/api';
//prefix path with username
let url = apiBase + `/${this.main.username}` ;
if(path){
    if(path.startsWith('/')){
        url = url + path;
    }else{
        url = url + `/${path}`;
    }
    
}
if(searchParams){
let params = new URLSearchParams();
for(let p of searchParams){
params.append(p.n, p.v);
}
url = url + `?${params}`;
}
this.main.log(url,'FetchUtils.getApi(): fetch link');
return url;
}//

///######## FETCH OPS ########
/**
 * 
 * @param {string} email 
 * @returns 
 */
async getToken(email){
return await this.fetch({
  link:this.getApi('get-token'),
  body:JSON.stringify({email:email})
});
}

}//class